import * as React from "react";
import { Typeahead } from 'react-bootstrap-typeahead';

import { GeotabSensor } from "../../../../../models/IdName";
import { Polyglot } from "../../../../../polyglot";
import { TypeaheadEnterEscWrapper } from "../../../TypeaheadEnterEscWrapper";

interface Props
{
    polyglot: Polyglot;    
    disabled?: boolean;
    nativeSensorId: string;
    nativeSensors: GeotabSensor[];    
    setNativeSensor: (geotabSensor: GeotabSensor) => void;
}

const getNativeSensorDisplay = (s: GeotabSensor) => s.Name;

export class NativeSensorSelector extends React.Component<Props, any>
{
    private typeahead: any;
    render()
    {
        const { polyglot,nativeSensorId, nativeSensors, setNativeSensor } = this.props;
        const geotab = nativeSensors.find(item => item.Id === nativeSensorId);
        const selectedGeotab = geotab ? [geotab] : [];

        return (
            <TypeaheadEnterEscWrapper>
                <Typeahead ref={e => this.typeahead = e}
                    disabled={this.props.disabled}
                    placeholder={polyglot.t('sensor.placeholder_sensor')}
                    labelKey={getNativeSensorDisplay} options={nativeSensors} selected={selectedGeotab}
                    onChange={(values: GeotabSensor[]) => setNativeSensor(values[0]) }
                />
            </TypeaheadEnterEscWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/EditCreateSensor/NativeSensorSelector.tsx